import React, { useCallback, useMemo, useState } from 'react';

import OpencareRewardsModal from 'pages/results/components/OpencareRewardsModal/OpencareRewardsModal';
import { useOfferService } from 'services/OfferService';

import { EXPERIMENTS } from 'utils/constants/experiment-configs';
import { useExperiment } from 'utils/customHooks/useExperiment';

import {
  Container,
  ContentWrapper,
  GiftIcon,
  OfferText,
  SeeHowButton,
  Wrapper,
} from './OfferBanner-styled-components';

export const OfferBanner = () => {
  const { hasActiveOffer, formattedReferralOfferName, offerName, isThirdPartyOffer } = useOfferService();
  const offerNameText = useMemo(() => formattedReferralOfferName || offerName, [formattedReferralOfferName, offerName]);

  const [opencareRewardsModalVisible, setOpencareRewardsModalVisible] = useState(false);
  const handleSeeHow = useCallback(() => setOpencareRewardsModalVisible(true), []);

  const { variant } = useExperiment({
    experiment: EXPERIMENTS.CHECKOUT_REDESIGN,
    skipTracking: true,
  });
  const isRedesignWithBannerVariant = variant === '1';

  if (!hasActiveOffer || !isRedesignWithBannerVariant) {
    return null;
  }

  return (
    <>
      <Wrapper>
        <Container>
          <ContentWrapper>
            <GiftIcon />
            <OfferText>{offerNameText}</OfferText>
          </ContentWrapper>
          <SeeHowButton onClick={handleSeeHow}>
            See How
          </SeeHowButton>
        </Container>
      </Wrapper>

      <OpencareRewardsModal
        offerName={offerName}
        isThirdPartyOffer={isThirdPartyOffer}
        opencareRewardsModalVisible={opencareRewardsModalVisible}
        setOpencareRewardsModalVisible={setOpencareRewardsModalVisible}
      />
    </>
  );
};
